import { type SetState } from '../store';
import { type TrackingEvent } from '@/tracking/tracking-manager';

export type TrackingSliceProps = {
    tracking: {
        sendEvent: (events: TrackingEvent[]) => void;
        setSendEvent: (sendEventFn: (events: TrackingEvent[]) => void) => void;
        eventQueue?: TrackingEvent[];
        initialized: boolean;
    };
};

export const trackingSlice = ({ set, get }: SetState<TrackingSliceProps>): TrackingSliceProps => ({
    tracking: {
        sendEvent: (events: TrackingEvent[]) => {
            const { sendEvent, initialized } = get().tracking;
            if (!initialized) {
                set(
                    (state) => ({
                        tracking: {
                            ...state.tracking,
                            eventQueue: [...(state.tracking.eventQueue || []), ...events]
                        }
                    }),
                    undefined,
                    'tracking/bufferEvents'
                );
            } else {
                sendEvent(events);
            }
        },
        setSendEvent: (sendEventFn: (events: TrackingEvent[]) => void) => {
            const { eventQueue } = get().tracking;
            set(
                (state) => ({
                    tracking: {
                        ...state.tracking,
                        sendEvent: sendEventFn,
                        initialized: true
                    }
                }),
                undefined,
                'tracking/setSendEvent'
            );

            // consume any queued events
            if (eventQueue && eventQueue.length > 0) {
                sendEventFn(eventQueue);
                set(
                    (state) => ({
                        tracking: {
                            ...state.tracking,
                            eventQueue: []
                        }
                    }),
                    undefined,
                    'tracking/flushBuffer'
                );
            }
        },
        eventQueue: [],
        initialized: false
    }
});
